// Single 31-day timeline view. The key intentionally is NOT "resourceTimelineMonth":
// that name makes FullCalendar derive a calendar-month duration (28-31 days) that takes
// priority over `visibleRange`. A custom key keeps the view duration-free so our explicit
// 31-day range is always honored.
export const ABS_MONTH_VIEW = 'resourceTimelineScrollMonth';
export const ABS_DAY_VIEW = 'resourceTimelineDay';

export const ABSENCE_BLOCK_POSITION_START = 'start';
export const ABSENCE_BLOCK_POSITION_MIDDLE = 'middle';
export const ABSENCE_BLOCK_POSITION_END = 'end';
export const ABSENCE_BLOCK_POSITION_SINGLE = 'single';
